<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Draft Kirim Invent</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    Kirim invetaris dari gudang: <strong>{{ data.warehouse}}</strong><br />
                    No. Request <strong>{{ data.sendback_request_number || "-" }}</strong><br />
                    Divisi barang: <strong>{{ data.division }}</strong><br />
                    Kategori: <strong>{{ data.inventory_category || "-" }}</strong> <br />
                    Dikirim Ke: <strong>{{ data.sent_to || "-" }}</strong><br />
                    Total <strong>{{ data.total_item }}</strong> barang
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="danger" @click="cancelPindahBarang">
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="promptPindahBarang">
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="!data.sendback_request_number">
                <b-col md="6">
                    <b-input-group>
                        <b-input v-model="input.noFaktur" maxlength="100" style="max-width: 250px" placeholder="Input No. Faktur..." @keydown.enter="addItem" />
                        <b-input-group-append>
                            <b-button variant="dark" @click="addItem" :disabled="isEditing">Tambah Barang</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="items"
                :fields="fields"
                :busy="isBusy"
                responsive class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Belum ada barang yang dipindahkan.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" :disabled="isEditing" @click="removeItem(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-confirm-movement" title="Finalisasi Dokumen" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan Kirim Invent">
                <b-input v-model="movement.note" maxlength="200" />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="execPindahBarang">
                    Kirim inventaris
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-print" title="Cetak Invoice" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            Pastikan kirim inventaris sudah tercetak dengan baik sebelum melanjutkan.
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">

                        <b-button variant="primary" @click="hideInvoiceModal">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isEditing: false,
            isBusy: false,

            invoiceLink: "",
            invoiceLinkA4: "",

            data: {},

            items: [],

            input: {
                noFaktur: ""
            },

            movement: {
                note: "",
                noRef: "",
                moveDate: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No." },
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

            barcodeLink: "",
            barcodeLinkDamage: "",

            barcodeType: 'barcode',
            barcodeToggleCooldown: false

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getDraftItems()
            .catch(error => this.$helper.parseError(this, error))

            Promise.all([getData]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)

        },

        addItem() {
            if(this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            let payload = {
                no_faktur_pgi: this.input.noFaktur,
            }

            this.isEditing = true

            this.$axios.post("inventory-pgi/add/"+this.$route.params.id, payload).then(_ => {
                this.$helper.toastSuccess(this, "Barang berhasil ditambahkan!")
                this.input.noFaktur = ""
                this.getDraftItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isEditing = false)

        },

        removeItem(item) {

            let confirmed = confirm(`Hapus ${item.type} (NF ${item.no_faktur_pgi}) dari kirim inventaris ini?`)
            if(!confirmed) return

            this.isEditing = true

            this.$axios.delete("inventory-pgi/details/"+this.data.sendback_id+"/item/"+item.sendback_detail_id).then(_ => {
                this.$helper.toastSuccess(this, "Barang berhasil dihapus!")
                this.getDraftItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isEditing = false)

        },

        cancelPindahBarang() {

            let isConfirmed = confirm("Batalkan kirim inventaris ini? Draft akan dihapus dan barang-barang akan dikembalikan ke status semula!")
            if(!isConfirmed) return

            let payload = {
                id: this.$route.params.id
            }

            this.$axios.delete("inventory-pgi/cancel/"+this.$route.params.id, payload).then(_ => {
                this.$router.push({ path: "/kirim-inven/list" })
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        hideInvoiceModal() {
            this.$router.push({ path: "/kirim-inven/list" });
            this.isShowing = false;
            this.$bvModal.hide('m-print');
        },

        promptPindahBarang() {

            if(this.items.length == 0) {
                return this.$helper.toastError(this, "Belum ada barang yang akan dipindahkan!")
            }

            this.movement.noRef = ""
            let tzoffset = (new Date()).getTimezoneOffset() * 60000
            let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
            this.movement.moveDate = localISOTime.substring(0, 10)
            this.movement.note = ""

            this.$bvModal.show("m-confirm-movement")

        },

        getBarcodeLink() {
            if(this.barcodeType == 'barcode'){
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if(this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function(){
                this.barcodeToggleCooldown = false
            }.bind(this),2000);
        },

        execPindahBarang() {


            let isConfirmed = confirm("Jalankan Kirim Invent ini? Proses ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            let payload = {
                notes: this.movement.note,
            }

            this.isSubmitting = true
            this.$axios.post("inventory-pgi/finalize/"+this.$route.params.id, payload ).then(res => {

                let result = res.data.data
                if(result.fail == 0){
                    this.$helper.toastSuccess(this, `Kirim Invent berhasil dijalankan! barang berhasil dipindahkan.`)
                }
                else{
                    this.$helper.toastSuccess(this, `Kirim Invent berhasil dijalankan! barang berhasil dipindahkan`)
                }
                this.$bvModal.hide("m-confirm-movement")
                const cleanedString = res.data.data.link.replace(/\\/g, "");
                const cleanedStringa4 = res.data.data.linka4.replace(/\\/g, "");
                this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}${cleanedString}`;
                this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}${cleanedStringa4}`
                this.barcodeLink = res.data.data.barcodeLink
                this.barcodeLinkDamage = res.data.data.barcodeLinkDamage
                this.$bvModal.show("m-print")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        openBarcodeModal() {
            this.$bvModal.hide("m-print")
            this.$bvModal.show("m-barcode")
        },

        finishPindahBarang() {
            this.$router.push({ path: "/pindah-gudang" })
        },

        getDraftItems(page){
            this.isBusy = true

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-pgi/draft/" + this.$route.params.id + param).then(res => {
                this.items = res.data.data.details.items.map(item => {
                    return {
                        id: item.item_id,
                        type: item.type,
                        brand: item.brand,
                        kind: item.kind,
                        year: item.year,
                        no_faktur_pgi: item.no_faktur_pgi,
                        imei_sn: item.imei_sn,
                        sendback_detail_id: item.sendback_detail_id,
                    }
                })

                this.data = res.data.data
                this.totalRows = res.data.data.details.total || 0;
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isBusy = false })
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getDraftItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getDraftItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getDraftItems()
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.invoiceLink
            }
            else{
                return this.invoiceLinkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

    },
    created() {

        this.init()

        let tzoffset = (new Date()).getTimezoneOffset() * 60000
        let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
        this.movement.moveDate = localISOTime.substring(0, 10)

    }
}
</script>

<style>

</style>
